import { render, staticRenderFns } from "./NoStudySetModal.vue?vue&type=template&id=740a80d4&scoped=true&"
import script from "./NoStudySetModal.vue?vue&type=script&lang=js&"
export * from "./NoStudySetModal.vue?vue&type=script&lang=js&"
import style0 from "./NoStudySetModal.vue?vue&type=style&index=0&id=740a80d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a80d4",
  null
  
)

export default component.exports